import { createSlice } from "@reduxjs/toolkit";
import { getBankLoan } from "../reduxApi/BankLoanReduxApi";

const bankLoanSlice = createSlice({
    name: 'bankLoan',
    initialState: {
        status: 'idel',
        isFiltered: false,
        bankLoan: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteBankLoanAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.bankLoan.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.bankLoan.splice(index, 1);
                }
            });
        },
        updateBankLoanAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.bankLoan.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.bankLoan.splice(index, 1,  action.payload)
            }
        },
        addBankLoanAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.bankLoan.unshift({ temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getBankLoan.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getBankLoan.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.bankLoan = action.payload.data.bankLoanMasters;
            })
    }
})
export const { deleteBankLoanAction, updateBankLoanAction, addBankLoanAction,setFilteredStatus } = bankLoanSlice.actions
export default bankLoanSlice.reducer